import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import { arrayToObject } from 'lib/array/arrayUtils'
import qs from 'qs'

type Response = paths['/api/merchandise/search/adverts']['get']['responses']['200']['content']['application/json']

async function getMerchandiseList(filters: App.MerchandiseFilters): Promise<Array<string>> {
  const query = qs.stringify({
    name: filters.name || undefined,
    categoryIds: filters.categories?.length ? filters.categories : undefined,
    brandIds: filters.brands?.length ? filters.brands : undefined,
    priceMin: filters.price?.min ?? undefined,
    priceMax: filters.price?.max ?? undefined,
    pointMin: filters.points?.min ?? undefined,
    pointMax: filters.points?.max ?? undefined,
    // search facets endpoint assumes any other field is an option filter
    ...arrayToObject(filters.options ?? [], option => option.type, option => option.value),
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/search/adverts?${query}`, { excludeBrand: true }).then((response) => {
    return response.result.advertIds
  })
}

export default getMerchandiseList
